// src/components/FriendsLeaderboard.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { getFriends } from '../services/connectionService';
import { getSwapTransactions, calculatePnL, formatNumber } from '../services/leaderboardService';
import '../styles/FriendsLeaderboard.css';

const FriendsLeaderboard = ({ walletAddress, onClose }) => {
  const [friendsData, setFriendsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Fetch friends list and their PnL data
  const fetchFriendsData = useCallback(async () => {
    if (!walletAddress) return;
    
    try {
      setLoading(true);
      
      // Get the user's friends
      const friends = await getFriends(walletAddress);
      
      // Add the user to the list so they can see their own stats
      const userItem = {
        walletAddress: walletAddress,
        username: 'You', // Special label for the user
        isCurrentUser: true
      };
      
      const allUsers = [userItem, ...friends];
      
      // Calculate PnL for each friend
      // In src/components/FriendsLeaderboard.jsx
// Inside the fetchFriendsData function

// Calculate PnL for each friend
const friendsWithPnL = [];

for (const friend of allUsers) {
  try {
    const swaps = await getSwapTransactions(friend.walletAddress);
    const { profit, tokenCount } = calculatePnL(swaps);
    
    friendsWithPnL.push({
      ...friend,
      profit: profit || 0,
      tokenCount: tokenCount || 0
    });
  } catch (err) {
    console.error(`Failed to get PnL for ${friend.username}:`, err);
    
    // Still add the friend, but with 0 profit and tokens
    friendsWithPnL.push({
      ...friend,
      profit: 0,
      tokenCount: 0
    });
  }
}
      
      // Sort by profit (highest first)
      friendsWithPnL.sort((a, b) => b.profit - a.profit);
      
      setFriendsData(friendsWithPnL);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching friends data:', error);
      setError('Failed to load friends data');
      setLoading(false);
    }
  }, [walletAddress]);

  useEffect(() => {
    fetchFriendsData();
  }, [fetchFriendsData]);

  const formatWallet = (wallet) => {
    if (!wallet) return '';
    return `${wallet.substring(0, 6)}...${wallet.substring(wallet.length - 4)}`;
  };

  return (
    <div className="friends-leaderboard-container">
      <div className="friends-leaderboard-header">
        <h2>Friends Leaderboard</h2>
        <button className="close-btn" onClick={onClose}>×</button>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-indicator"></div>
          <p>Loading friends data...</p>
        </div>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : friendsData.length === 0 ? (
        <div className="empty-state">
          <p>No friends found. Add friends to see their stats here.</p>
        </div>
      ) : (
        <div className="friends-leaderboard-content">
          <div className="friends-leaderboard-title">
            <span>Your circle's performance (24h)</span>
          </div>
          

<table className="friends-table">
  <thead>
    <tr>
      <th>Rank</th>
      <th>Username</th>
      <th>Wallet</th>
      <th>PnL</th>
      <th>Trades</th> {/* New column */}
    </tr>
  </thead>
  <tbody>
    {friendsData.map((friend, index) => (
      <tr key={friend.walletAddress} className={friend.isCurrentUser ? 'current-user' : ''}>
        <td className="rank-cell">#{index + 1}</td>
        <td className="username-cell">
          {friend.username}
          {friend.isCurrentUser && <span className="you-badge">You</span>}
        </td>
        <td className="wallet-cell">
          <a 
            href={`https://gmgn.ai/sol/address/${friend.walletAddress}`}
            className="wallet-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            {formatWallet(friend.walletAddress)}
          </a>
        </td>
        <td className={`pnl-cell ${friend.profit < 0 ? 'negative' : 'positive'}`}>
          {formatNumber(friend.profit)} SOL
        </td>
        <td className="tokens-cell">{friend.tokenCount}</td> {/* Display token count */}
      </tr>
    ))}
  </tbody>
</table>
        </div>
      )}
    </div>
  );
};

export default FriendsLeaderboard;